import {Switch as RacSwitch, type SwitchProps} from 'react-aria-components'

import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './Switch.module.scss'

interface Props {
  label: string | ReactNode
  onChange?: MemoizedCallbackOrDispatch<boolean>
  labelClassName?: string | ReactNode
  isLabelVisible?: boolean
}

export default memo(function Switch(props: Omit<SwitchProps, 'children' | 'onChange'> & Props) {
  return (
    <RacSwitch {...props} className={clsx(style.Switch, props.className)}>
      <div className={style.SwitchHandleContainer}>
        <div className={style.SwitchHandle} />
      </div>
      <VisuallyHidden
        as='span'
        isVisible={!!props.isLabelVisible}
        className={clsx(style.SwitchLabel, props.labelClassName)}
      >
        {props.label}
      </VisuallyHidden>
    </RacSwitch>
  )
})
